"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const index_view_1 = __importDefault(require("./index.view"));
const AddSystemModal_1 = __importDefault(require("@/pages/Sites/components/SystemForms/AddSystemModal"));
const EditSystemModal_1 = __importDefault(require("@/pages/Sites/components/SystemForms/EditSystemModal"));
const Main_1 = __importDefault(require("@/components/Main"));
const AddSiteModal_1 = __importDefault(require("./components/SiteForms/AddSiteModal"));
function Sites() {
    return (react_1.default.createElement(Main_1.default, null,
        react_1.default.createElement(Grid_1.default, { container: true },
            react_1.default.createElement(index_view_1.default, null),
            react_1.default.createElement(AddSiteModal_1.default, null),
            react_1.default.createElement(AddSystemModal_1.default, null),
            react_1.default.createElement(EditSystemModal_1.default, null))));
}
exports.default = Sites;
